export default __webpack_public_path__ + "static/media/slider_7_ru.e64864d1.png";